module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header-item header-menu",
    on: {
      "click": function($event) {
        _vm.toggleSidebar()
      }
    }
  }, [_c('div', {
    staticClass: "header-hamburger",
    class: {
      active: _vm.showSidebar
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header-logo",
    on: {
      "click": _vm.goHome
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": "Stocker 3.0"
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.user != null),
      expression: "user != null"
    }],
    staticClass: "header-item header-logout button iconOnly",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "i"
  }, [_vm._v("exit_to_app")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-1b6eef51"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 64
// module chunks = 0